/**
 * Whether a statement's Void action is offered. It follows the API's rule for voiding a statement: where the company
 * has voiding turned off, only Livable staff may void, and only a final statement.
 */
export const canVoidStatement = _ref => {
  let disableVoidStatement = _ref.disableVoidStatement,
    isFinalStatement = _ref.isFinalStatement,
    isLivableStaff = _ref.isLivableStaff;
  return !disableVoidStatement || !!isFinalStatement && !!isLivableStaff;
};